import {
    genders,
    nationalities,
    bloodTypes,
    doctrines,
    religions,
    maritalStatus,

    admissionChannel,
    educationalLevel,
    shiftType,
    studyType,
    continuityStudy,
    stage,
    wantReturn,

    publishing,
    endorsementStatus,
    isRetired,

    socialMediaStatus,

    relationships,

    universityTypes,

    active,
    userType,

} from "@/helpers/list/lists";
import { splitDateTime } from "@/helpers/helper_func";

//#region General Helper Functions
export const findInList = (list, value) => list.find(a => a.value == value) ?? null;

export const mapList = (x) => (x ? { value: x.id, label: x.name } : null);

export const mapListFrom2Level = (x) => (x ? { value: x.value, label: x.label } : null);

export const mapList2Level = (x) => {
  if (!x) return null;
  const childKey = Object.keys(x).find(key => typeof x[key] === 'object' && x[key] !== null);
  return childKey && x[childKey] 
    ? { value: x.id, label: x.name, child: { value: x[childKey].id, label: x[childKey].name } }
    : { value: x.id, label: x.name };
};

const mapTableDataBaseFields = (item) => ({
    id: item.id,
    code: item.code,
    fullName: item.fullName,
    lastName: item.lastName,
    gender: findInList(genders, item.gender),
    motherName: item.motherName,
    dateOfBirth: item.dateOfBirth,
    maritalStatus: maritalStatus.find(a => a.value == item.maritalStatus && a.gender == (item.gender == 1 ? "male" : "female")) ?? null,
    governorateName: item.governorateName,
    religionEnum: findInList(religions, item.religionEnum),
    doctrineEnum: findInList(doctrines, item.doctrineEnum),
    nationalityEnum: findInList(nationalities, item.nationalityEnum),
});

const mapPersonBaseArgs = (x) => [
    x.code,
    x.id,
    x.firstName,
    x.secondName,
    x.thirdName,
    x.forthName,
    x.lastName,
    x.dateOfBirth,
    x.motherName,
    maritalStatus.find(a => a.value == x.maritalStatus && a.gender == (x.gender == 1 ? "male" : "female")) ?? null,
    findInList(bloodTypes, x.bloodType),
    findInList(nationalities, x.nationalityEnum),
    findInList(religions, x.religionEnum),
    findInList(doctrines, x.doctrineEnum),
    findInList(genders, x.gender),
    x.notes
];

const getResidence = (x) => 
    x.governorateName ? 
        mapResidence({
            id: 0,
            personId: x.id,
            governorates: { id: x.governorateId, name: x.governorateName }
        }) 
        : (x.residenceData ? mapResidence(x.residenceData) : null);
//#endregion

//#region Mappers for Admin Models
import Admin from '@/model/admin.js';
export const mapAdmin = (x) => {
    if (!x) return null;
    return new Admin(
        x.id,
        x.personName,
        x.description,
        x.username,
        null, // we don't map the password for security reasons
        findInList(userType, x.type),
        findInList(active, x.active),
    )
    .setRoles(x.roleIds ?? [])
    .setPermissions(x.permissionIds ?? [])
    .setCategories(x.categoryIds ?? [])
    .setPersonTypes(x.personTypeIds ?? [])
    .setRegions(x.regionIds ?? [])
    .setPersonTypeOperations(x.personTypeOperations ?? [])
    .setCategoryPersonTypeOperations(x.categoryPersonTypeOperations ?? [])
};
//#endregion

//#region Mappers for DataTable Models
export const mapTableDataAdmin = (data) => data.map((item) => ({
    id: item.id,
    fullName: item.fullName,
    accountName: item.accountName,
    personName: item.personName,
    accountDescription: item.accountDescription,
    isActive: findInList(active, item.isActive),
    userType: findInList(userType, item.userTypeId),
    lastLoginDate: item.lastLoginDate && item.lastLoginDate.trim().length > 0 ? splitDateTime(item.lastLoginDate || "") : "",
    // createdAt: item.createdAt,
    // updatedAt: item.updatedAt,
}));
export const mapTableDataMartyr = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    dateSacrifice: item.dateSacrifice,
}));

export const mapTableDataWounded = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    phoneNumber: item.phoneNumber,
    educationLevel: findInList(educationalLevel, item.educationLevel),
    dateOfInjury: item.dateOfInjury,
    disabilityPercentage: item.disabilityPercentage,
}));

export const mapTableDataDeceased = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    dateOfDeath: item.dateOfDeath,
}));

export const mapTableDataBeneficiary = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    phoneNumber: item.phoneNumber,
    educationLevel: findInList(educationalLevel, item.educationLevel),
    personType: mapList(item.personType || item.personTypeId),
    relationshipType: findInList(relationships, item.relationshipType),
    sacrificerName: item.sacrificerName,
}));

export const mapTableDataSacrificer = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    personType: mapList(item.personType || item.personTypeId),
}));

export const mapTableDataAllPersonTypes = (data) => data.map((item) => ({
    ...mapTableDataBaseFields(item),
    personType: mapList(item.personType || item.personTypeId),
    percentage: item.completionPercentage,
    lastUpdate: item.lastUpdate?.substr(0,10),
}));
//#endregion

//#region Mappers for Person Models
import Sacrificer from '@/model/sacrificer.js';
export const mapSacrificer = (x) => {
    if (!x) return null;
    return new Sacrificer(...mapPersonBaseArgs(x))
        .setPersonType(mapList(x.personType || x.personTypeId))
        .setResidence(getResidence(x))
        .setMembers(x.members?.map(mapBeneficiary) ?? []);
};

import Martyr from '@/model/martyr.js';
export const mapMartyr = (x) => {
    if (!x) return null;
        console.log(x)

    return new Martyr(...mapPersonBaseArgs(x))
        .setPersonType(mapList(x.personType || x.personTypeId))
        .setResidence(getResidence(x))
        .setEducations(x.educationData?.map(mapEducationData) ?? [])
        .setArchiveFiles(x.files?.map(mapArchive) ?? [])
        .setEmploymentRecord(x.employmentRecord ? mapEmploymentRecord(x.employmentRecord) : null)
        .setPreviousEmployment(x.previousEmployment ? mapPreviousEmployment(x.previousEmployment) : null)
        .setAdministrativeData(x.administrativeData ? mapAdministrativeData(x.administrativeData) : null)
        .setMembers(x.members?.map(mapBeneficiary) ?? [])
        .setDeathCertificate(x.deathCertificates ? mapDeathCertificate(x.deathCertificates) : null)
        .setMartyrData(x.martyrData ? mapMartyrData(x.martyrData) : null)
        .setProfileStatistics({completionPercentage: x.completionPercentage, lastUpdate: x.lastUpdate?.substr(0,10)});
};

import Wounded from '@/model/wounded.js';
export const mapWounded = (x) => {
    if (!x) return null;
    return new Wounded(...mapPersonBaseArgs(x))
        .setPersonType(mapList(x.personType || x.personTypeId))
        .setResidence(getResidence(x))
        .setEducations(x.educationData?.map(mapEducationData) ?? [])
        .setArchiveFiles(x.files?.map(mapArchive) ?? [])
        .setEmploymentRecord(x.employmentRecord ? mapEmploymentRecord(x.employmentRecord) : null)
        .setPreviousEmployment(x.previousEmployment ? mapPreviousEmployment(x.previousEmployment) : null)
        .setAdministrativeData(x.administrativeData ? mapAdministrativeData(x.administrativeData) : null)
        .setMembers(x.members?.map(mapBeneficiary) ?? [])
        .setSkills(x.skills?.map(mapSkill) ?? [])
        .setSacrifices(x.sacrificialData?.map(mapSacrificeData) ?? [])
        .setContacts(x.contacts?.map(mapContact) ?? [])
        .setSelfEmployment(x.selfEmployment?.map(mapSelfEmployment) ?? [])
        .setSocialMedia(x.socialMedia ? mapSocialMedia(x.socialMedia) : null)
        .setNewIdentificationCard(x.newIdentificationCards ? mapNewIdentificationCard(x.newIdentificationCards) : null)
        .setOldIdentificationCard(x.oldIdentificationCards ? mapOldIdentificationCard(x.oldIdentificationCards) : null)
        .setPassport(x.passports ? mapPassport(x.passports) : null)
        .setRationCard(x.rationCards ? mapRationCard(x.rationCards) : null)
        .setResidentialCard(x.residentialCards ? mapResidentialCard(x.residentialCards) : null)
        .setProfileStatistics({completionPercentage: x.completionPercentage, lastUpdate: x.lastUpdate?.substr(0,10)});
};

import Deceased from '@/model/deceased.js';
export const mapDeceased = (x) => {
    if (!x) return null;
    return new Deceased(...mapPersonBaseArgs(x))
        .setPersonType(mapList(x.personType || x.personTypeId))
        .setResidence(getResidence(x))
        .setArchiveFiles(x.files?.map(mapArchive) ?? [])
        .setEmploymentRecord(x.employmentRecord ? mapEmploymentRecord(x.employmentRecord) : null)
        .setAdministrativeData(x.administrativeData ? mapAdministrativeData(x.administrativeData) : null)
        .setMembers(x.members?.map(mapBeneficiary) ?? [])
        .setDeathCertificate(x.deathCertificates ? mapDeathCertificate(x.deathCertificates) : null)
        .setEducations(x.educationData?.map(mapEducationData) ?? [])
        .setProfileStatistics({completionPercentage: x.completionPercentage, lastUpdate: x.lastUpdate?.substr(0,10)});
};

import Beneficiary from '@/model/beneficiary.js';
export const mapBeneficiary = (x) => {
    if (!x) return null;
    return new Beneficiary(
        ...mapPersonBaseArgs(x),
        findInList(relationships, x.relationship),
        x.family_id ?? null
    )
        .setPersonType(mapList(x.personType || x.personTypeId))
        .setResidence(getResidence(x))
        .setEducations(x.educationData?.map(mapEducationData) ?? [])
        .setArchiveFiles(x.files?.map(mapArchive) ?? [])
        .setSkills(x.skills?.map(mapSkill) ?? [])
        .setContacts(x.contacts?.map(mapContact) ?? [])
        .setSelfEmployment(x.selfEmployment?.map(mapSelfEmployment) ?? [])
        .setSocialMedia(x.socialMedia ? mapSocialMedia(x.socialMedia) : null)
        .setNewIdentificationCard(x.newIdentificationCards ? mapNewIdentificationCard(x.newIdentificationCards) : null)
        .setOldIdentificationCard(x.oldIdentificationCards ? mapOldIdentificationCard(x.oldIdentificationCards) : null)
        .setPassport(x.passports ? mapPassport(x.passports) : null)
        .setRationCard(x.rationCards ? mapRationCard(x.rationCards) : null)
        .setResidentialCard(x.residentialCards ? mapResidentialCard(x.residentialCards) : null)
        .setMembers(x.members?.map(mapBeneficiary) ?? [])
        .setJobRecord(x.jobRecords ? mapJobRecord(x.jobRecords) : null)
        .setProfileStatistics({completionPercentage: x.completionPercentage, lastUpdate: x.lastUpdate?.substr(0,10)})
        .setSacrificer(x.sacrificer ? mapSacrificer(x.sacrificer) : null);
    };
//#endregion

//#region mappers for associated models with person
import Residence from '@/model/residence.js';
export const mapResidence = (x) => {
    if (!x) return null;
    return new Residence(
        x.id,
        x.personId?.id,
        mapList(x.governorates),
        mapList(x.districts),
        mapList(x.townships),
        mapList(x.regions),
        x.mahalleh,
        x.zoghagh,
        x.dar,
        x.closestResidential,
        x.latitude,
        x.longitude,
        mapList(x.housingType),
        mapList(x.ownershipType),
        x.notes
    );
};

import FileInfo from '@/model/fileInfo.js';
export const mapFileInfo = (x) => {
    if (!x) return null;
    return new FileInfo(
        x.id,
        x.path
    );
};

import DeathCertificate from '@/model/deathCertificate.js';
export const mapDeathCertificate = (x) => {
    if (!x) return null;
    return new DeathCertificate(
        x.deathCertificatesResponse?.id,
        x.deathCertificatesResponse?.personId,
        x.deathCertificatesResponse?.certificateNumber,
        x.deathCertificatesResponse?.dateOfIssue,
        mapFileInfo(x.filesForm)
    );
};

import MartyrData from '@/model/martyrData.js';
export const mapMartyrData = (x) => {
    if (!x) return null;
    return new MartyrData(
        x.martyrDataResponse?.id,
        x.martyrDataResponse?.personId,
        x.martyrDataResponse?.dateSacrifice,
        x.martyrDataResponse?.hospitalName,
        mapList(x.martyrDataResponse?.placeSacrifice),
        x.martyrDataResponse?.notes,
        mapFileInfo(x.filesForm)
    );
};

import EducationCurrentData from '@/model/educationCurrentData.js';
export const mapEducationCurrentData = (x) => {
    if (!x) return null;
    return new EducationCurrentData(
        x.id,
        x.personId,
        findInList(educationalLevel, x.educationalLevel),
        mapList(x.department),
        x.school,
        x.major,
        findInList(stage, x.stage),
        findInList(admissionChannel, x.admissionChannel),
        findInList(studyType, x.studyType),
        findInList(shiftType, x.shiftType),
        findInList(continuityStudy, x.isContinuous),
        x.reason,
        findInList(wantReturn, x.isWantReturn),
        x.notes
    );
};

import EducationData from '@/model/educationData.js';
export const mapEducationData = (x) => {
    if (!x) return null;
    return new EducationData(
        x.id,
        x.personId,
        findInList(educationalLevel, x.educationalLevel),
        x.graduationYear,
        findInList(studyType, x.studyType),
        findInList(shiftType, x.shiftType),
        x.major,
        x.schoolName,
        mapList(x.educationalInstitution),
        mapList(x.college),
        mapList(x.department),
        mapList(x.admissionChannel),
        x.notes,
        mapFileInfo(x.file)
    );
};

import AdministrativeData from '@/model/administrativeData.js';
export const mapAdministrativeData = (x) => {
    if (!x) return null;
    return new AdministrativeData(
        x.id,
        x.personId,
        mapList(x.placeAffiliation),
        mapList(x.almelak),
        x.position ? { ...mapList(x.position), level: x.position.level } : null,
        mapList(x.levelOne),
        mapList(x.levelTwo),
        mapList(x.levelThree),
        x.notes,
    );
};

import EmploymentRecord from '@/model/employmentRecord.js';
export const mapEmploymentRecord = (x) => {
    if (!x) return null;
    return new EmploymentRecord(
        x.id,
        x.personId,
        findInList(publishing, x.publishing),
        x.statisticalNumber,
        x.salary,
        findInList(isRetired, x.retirementStatus),
        findInList(endorsementStatus, x.endorsementStatus),
        x.pensionNumber,
        x.dateAppointment,
        x.notes,
    );
};

import JobRecord from '@/model/jobRecord.js';
export const mapJobRecord = (x) => {
    console.log('mapping job record', x);
    if (!x) return null;
    return new JobRecord(
        x.id,
        x.personId,
        mapList(x.institution),
        x.workPlace,
        x.jobTitle,
        x.position,
        x.dateAppointment,
        findInList(studyType, x.type),
        x.notes,
    );
};

import PreviousEmployment from '@/model/previousEmployment.js';
export const mapPreviousEmployment = (x) => {
    if (!x) return null;
    return new PreviousEmployment(
        x.id,
        x.personId,
        x.perviousPlace,
        findInList(isRetired, x.retirementStatus),
        x.dateAppointment,
        x.notes,
    );
};

import { useCategoriesStore } from '@/state/pinia';
import Archive from '@/model/archive.js';
export const mapArchive = (x) => {
    if (!x) return null;
    let fileRelationship = useCategoriesStore().getCategoriesList.find(a => a.value === x?.fileRelationship);
    return new Archive(
        x.id,
        x.personId,
        new FileName(
            x.fileNameId,
            x.enName,
            x.arName,
            fileRelationship,
            x.active,
            x.fileNameDescription,
            x.size,
            x.extensions,
        ),
        new FileInfo(
            x.id,
            x.path,
            x.fileType,
            x.fileSize,
            x.description,
        )
    );
};

import NewIdentificationCard from '@/model/newIdentificationCard.js';
export const mapNewIdentificationCard = (x) => {
    if (!x) return null;
    return new NewIdentificationCard(
        x.newIdentificationCardsResponse?.id,
        x.newIdentificationCardsResponse?.personId,
        x.newIdentificationCardsResponse?.cardNumber,
        x.newIdentificationCardsResponse?.endDate,
        mapList(x.newIdentificationCardsResponse?.cardIssuer),
        mapFileInfo(x.fileFrontForm),
        mapFileInfo(x.fileBackForm)
    );
};

import OldIdentificationCard from '@/model/oldIdentificationCard.js';
export const mapOldIdentificationCard = (x) => {
    if (!x) return null;
    return new OldIdentificationCard(
        x.oldIdentificationCardsResponse?.id,
        x.oldIdentificationCardsResponse?.personId,
        x.oldIdentificationCardsResponse?.cardNumber,
        mapList(x.oldIdentificationCardsResponse?.cardIssuer),
        x.oldIdentificationCardsResponse?.record,
        x.oldIdentificationCardsResponse?.sheet,
        mapFileInfo(x.filesFrontForm),
        mapFileInfo(x.filesBackForm)
    );
};

import Passport from '@/model/passport.js';
export const mapPassport = (x) => {
    if (!x) return null;
    return new Passport(
        x.passportsResponse?.id,
        x.passportsResponse?.personId,
        x.passportsResponse?.passportCode,
        mapList(x.passportsResponse?.passportIssuer),
        x.passportsResponse?.expireDate,
        mapFileInfo(x.filesForm)
    );
};

import RationCard from '@/model/rationCard.js';
export const mapRationCard = (x) => {
    if (!x) return null;
    return new RationCard(
        x.rationCardsResponse?.id,
        x.rationCardsResponse?.personId,
        x.rationCardsResponse?.cardNumber,
        mapFileInfo(x.filesForm)
    );
};

import ResidentialCard from '@/model/residentialCard.js';
export const mapResidentialCard = (x) => {
    if (!x) return null;
    return new ResidentialCard(
        x.residentialCardResponse?.id,
        x.residentialCardResponse?.personId,
        x.residentialCardResponse?.cardNumber,
        mapList(x.residentialCardResponse?.cardIssuer),
        x.residentialCardResponse?.dateOfIssue,
        mapFileInfo(x.filesBackForm),
        mapFileInfo(x.filesFrontForm)
    );
};

import Contact from '@/model/contact.js';
export const mapContact = (x) => {
    if (!x) return null;
    return new Contact(
        x.id,
        x.personId,
        x.phoneNum,
        x.phoneStatus,
        findInList(socialMediaStatus, x.whatAppStatus),
        findInList(socialMediaStatus, x.telegramStatus),
    );
};

import SocialMedia from '@/model/socialMedia.js';
export const mapSocialMedia = (x) => {
    if (!x) return null;
    return new SocialMedia(
        x.id,
        x.personId,
        x.facebookUrl,
        x.facebookUser,
        x.instagramUrl,
        x.instagramUser,
    );
};

import SacrificeData from '@/model/sacrificeData.js';
import {
    useGovernorateStore,
  useDistrictsStore,
  useTownshipsStore,
  useRegionsStore,
 } from '@/state/pinia';
export const mapSacrificeData = (x) => {
    if (!x) return null;
    let r = useRegionsStore().regions.find(a => a.id === x.placeOfInjury?.id)
    let t = useTownshipsStore().townships.find(a => a.id === r?.townships?.id)
    let d = useDistrictsStore().districts.find(a => a.id === t?.districts?.id)
    let g = useGovernorateStore().governorates.find(a => a.id === d?.governorates?.id)

    return new SacrificeData(
        x.id,
        x.personId,
        x.healthNumber,
        x.disabilityRate,
        mapList(g),
        mapList(d),
        mapList(t),
        mapList(r),
        x.dateOfMedical,
        x.decisionOfMedical,
        x.injuryDetails,
        x.dateSacrifice,
        x.hospitalName,
        mapList(x.typesInjuries),
        mapList(x.bodyMainParts),
        mapList(x.bodySide),
        mapList(x.bodySubPart),
        x.notes,
        mapFileInfo(x.file),
    );
};

import SelfEmployment from '@/model/selfEmployment.js';
export const mapSelfEmployment = (x) => {
    if (!x) return null;
    return new SelfEmployment(
        x.id,
        x.personId,
        x.profession,
        x.workPlace,
        x.experienceYear,
        x.note,
    );
};

import FileName from '@/model/sutting/fileName'
export const mapFileName = (x) => {
    if (!x) return null;
    return new FileName(
        x.id,
        x.enName,
        x.arName,
        x.fileRelationship,
        x.active,
        x.description,
        x.size,
        x.extensions,
        x.created_at,
        x.updated_at
    );
}

import EducationalInstitution from '@/model/sutting/educationalInstitution'
export const mapEducationalInstitution = (x) => {
    if (!x) return null;
    return new EducationalInstitution(
        x.id,
        x.name,
        x.title,
        findInList(universityTypes, x.type),
        x.created_at,
        x.updated_at
    );
}
//#endregion

//#region mappers for setting models
import Permission from '@/model/sutting/permission'
const mapPermission = (x) => x ? new Permission(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Role from '@/model/sutting/role'
export const mapRole = (x) => x ? 
            new Role(x.roleId, x.roleName, x.roleTitle, x.created_at, x.updated_at)
            .setPermissions(x.permissions?.map(mapPermission) ?? [])
        : null

import BodyMainParts from '@/model/sutting/bodyMainPart'
export const mapBodyMainParts = (x) => x ? new BodyMainParts(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import AdmissionChannel from '@/model/sutting/admissionChannel';
export const mapAdmissionChannel = (x) => x ? new AdmissionChannel(x.id, x.name, x.title, x.created_at, x.updated_at) : null;

import Almelakat from '@/model/sutting/almelakat'
export const mapAlmelakat = (x) => x ? new Almelakat(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import BodySide from '@/model/sutting/bodySide'
export const mapBodySide = (x) => x ? new BodySide(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import BodySubPart from '@/model/sutting/bodySubPart'
export const mapBodySubPart = (x) => x ? new BodySubPart(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import College from '@/model/sutting/college'
export const mapCollege = (x) => x ? new College(x.id, x.name, x.title, x.type, x.created_at, x.updated_at) : null

import Department from '@/model/sutting/department'
export const mapDepartment = (x) => x ? new Department(x.id, x.name, x.title, x.type, x.created_at, x.updated_at) : null

import District from '@/model/sutting/district'
export const mapDistrict = (x) => x ? new District(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Governorate from '@/model/sutting/governorate'
export const mapGovernorate = (x) => x ? new Governorate(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import HousingType from '@/model/sutting/housingType'
export const mapHousingType = (x) => x ? new HousingType(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Institution from '@/model/sutting/institution'
export const mapInstitution = (x) => x ? new Institution(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import IssuerNewIdentificationCard from '@/model/sutting/issuerNewIdentificationCard'
export const mapIssuerNewIdentificationCard = (x) => x ? new IssuerNewIdentificationCard(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import IssuerOldIdentificationCard from '@/model/sutting/issuerOldIdentificationCard'
export const mapIssuerOldIdentificationCard = (x) => x ? new IssuerOldIdentificationCard(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import IssuerPassport from '@/model/sutting/issuerPassport'
export const mapIssuerPassport = (x) => x ? new IssuerPassport(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import IssuerResidentialCard from '@/model/sutting/issuerResidentialCard'
export const mapIssuerResidentialCard = (x) => x ? new IssuerResidentialCard(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import LevelOne from '@/model/sutting/levelOne'
export const mapLevelOne = (x) => x ? new LevelOne(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import LevelThree from '@/model/sutting/levelThree'
export const mapLevelThree = (x) => x ? new LevelThree(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import LevelTwo from '@/model/sutting/levelTwo'
export const mapLevelTwo = (x) => x ? new LevelTwo(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import OwnershipType from '@/model/sutting/ownershipType'
export const mapOwnershipType = (x) => x ? new OwnershipType(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import PlaceAffiliation from '@/model/sutting/placeAffiliation'
export const mapPlaceAffiliation = (x) => x ? new PlaceAffiliation(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Position from '@/model/sutting/position'
export const mapPosition = (x) => x ? new Position(x.id, x.name, x.title, x.level, x.created_at, x.updated_at) : null

import Region from '@/model/sutting/region'
export const mapRegion = (x) => x ? new Region(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Skill from '@/model/sutting/skill'
export const mapSkill = (x) => x ? new Skill(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Township from '@/model/sutting/township'
export const mapTownship = (x) => x ? new Township(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import TypeInjury from '@/model/sutting/typeInjury'
export const mapTypeInjury = (x) => x ? new TypeInjury(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Category from '@/model/sutting/category'
export const mapCategory = (x) => x ? new Category(x.id, x.name, x.description, x.created_at, x.updated_at) : null

import PersonType from '@/model/sutting/personType'
export const mapPersonType = (x) => x ? new PersonType(x.id, x.name, x.title, x.created_at, x.updated_at) : null

import Setting from '@/model/sutting/setting'
export const mapSetting = (x) => x ? new Setting(x.id, x.category, x.settingKey, x.valueType, x.settingValue, x.updatedAt, x.createdAt) : null

//#endregion